var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCallsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_9598)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_141_9598)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_141_9598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_9598",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.584 0H0.583984V24H24.584V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_9598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8559 24C13.6486 24 9.15564 22.454 5.64273 18.9412C2.13569 15.4341 0.583984 10.9442 0.583984 6.72811C0.583984 3.01238 3.59017 0 7.31209 0C7.59963 0 7.85814 0.175031 7.96492 0.441984L10.9774 7.97325C11.1217 8.33381 10.9463 8.74298 10.5858 8.88722L7.27656 10.2109C7.51066 14.018 10.5666 17.0737 14.3731 17.3075L15.6968 13.9983C15.8407 13.6383 16.2498 13.4623 16.6108 13.6066L24.142 16.6191C24.4089 16.7258 24.584 16.9844 24.584 17.2719C24.584 20.9876 21.5778 24 17.8559 24ZM6.84414 1.42641C4.15127 1.65942 1.99023 3.91758 1.99023 6.72811C1.99023 10.966 3.64052 14.9502 6.63714 17.9468C9.63372 20.9434 13.618 22.5938 17.8559 22.5938C20.6655 22.5938 22.9244 20.4339 23.1576 17.7398L16.7413 15.1733L15.4962 18.2861C15.3895 18.5531 15.1309 18.7281 14.8434 18.7281C9.88731 18.7281 5.85588 14.6967 5.85588 9.74137C5.85588 9.45389 6.03091 9.19453 6.29786 9.0878L9.41064 7.84266L6.84414 1.42641Z",
    fill: "#31BF5C"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_9598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_141_9598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_141_9598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCallsvg);
export default __webpack_public_path__ + "static/media/icn_call.svg.0b0a122c15460c2541c236cfb69d9b7b.svg";
export { ForwardRef as ReactComponent };